import Step from "components/MainApp/atoms/Wizard/Step";
import React from "react";

import styles from "./LoadRelocationOrder.Step2.module.scss";
import SearchWithComponents from "components/MainApp/atoms/Filters/SearchWithComponents";
import ProductAddedList from "components/MainApp/organisms/Orders/RequestOrders/ProductAddedList";
import i18n from "i18n";
import trashIcon from "assets/images/trash-icon.svg";

export const RelOrderStep2 = ({
  resultList,
  searchValue,
  handleChange,
  products,
  totalProducts,
  goBackFunc,
  handleSelectToAddProduct,
  handleSelectedProductQuantityChange,
  handleAdd,
  handleAddProduct,
  handleDeleteAddedProduct,
  selectedProducts,
  changePage,
  pagination
}) => {
  const stepContent = (
    <div className={styles["relocation-order-step-two-content"]}>
      <div
        className={styles["relocation-order-step-two-field"]}
        data-automation-id="input-search"
      >
        <SearchWithComponents
          placeholder={i18n.t("search.by.name.or.code")}
          resultList={resultList}
          value={searchValue}
          handleChange={handleChange}
          handleSelectToAddProduct={handleSelectToAddProduct}
          handleSelectedProductQuantityChange={
            handleSelectedProductQuantityChange
          }
          handleAdd={handleAdd}
          selectedProducts={selectedProducts}
          onlyStockHidden={true}
        />

        {products.length > 0 && (
          <ProductAddedList
            total={totalProducts}
            products={products}
            edit={true}
            handleEdit={handleAddProduct}
            handleDelete={handleDeleteAddedProduct}
            changePage={changePage}
            pagination={pagination}
            trashIcon={<img src={trashIcon} alt="trash icon" draggable={false} />}
          ></ProductAddedList>
        )}
      </div>
    </div>
  );
  return (
    <div className={styles["relocation-order-step-two-container"]}>
      <Step
        goBackFunc={goBackFunc}
        title={i18n.t("what.products.want.replenish")}
        content={stepContent}
      ></Step>
    </div>
  );
};

export default RelOrderStep2;
